import { Component, h, Method, Prop, State } from '@stencil/core';

@Component({
  tag: 'select-box',
  shadow: false,
})
export class InputText {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() required: boolean;
  @Prop() tooltip: string;
  @Prop() options: Array<{ value: string; label: string }>;
  @Prop() disabled: boolean;
  @Prop() dataTab: string;

  @State() data: string = '';
  @Method()
  async checkValidity(): Promise<boolean> {
    return this.data.trim().length > 0 || !this.required;
  }

  render() {
    return (
      <>
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
        <select class="form-select mb-3" data-tab={this.dataTab} name={this.name} disabled={this.disabled} required={this.required}>
          {this.options.map((opt: any) => (
            <option value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </>
    );
  }
}
